module.exports = __webpack_public_path__ + "img/KHM.7ae5025b.svg";